import Swiper from 'swiper/bundle';

export default function blockHomeSlider() {
  document.querySelectorAll('.block-home-slider__swiper:not(.block-home-slider__swiper--disabled)').forEach(function (slider) {

    const swiper = new Swiper(slider, {
      speed: 1000,
      loop: true,
      parallax: true,
      autoplay: {
        delay: 65000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: slider.querySelector('.slider__arrow--next'),
        prevEl: slider.querySelector('.slider__arrow--prev'),
      },
      pagination: {
        el: ".slider__pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      }

    });
  });
}